export { default } from 'features/store/pages/minimal-store-locator';
